<div class="tab-data-container">
	<div
		class="large-button"
		(click)="duplyRequestButton.classList.contains('confirm') ? duplyRequest(duplyRequestButton) : setConfirmButton(duplyRequestButton)"
		#duplyRequestButton>
		{{ labels.lbl_duplicar_chamado }}
	</div>
	@if (duplicateRequestInfo === true) {
		<div class="duplicate-request-container">
			<div class="description">
				<span class="label">{{ labels.lbl_geral_summary }}: </span>
				<input
					type="text"
					[value]="this.newRequestData.summary"
					(input)="this.newRequestData.summary = $any($event.target).value" />
			</div>
			<div class="description">
				<span class="label">{{ labels.lbl_geral_descricao }}: </span>
			</div>
			<div class="description">
				<textarea
					[ngStyle]="{ 'min-height': '48px', height: descriptionTextarea.scrollHeight + 'px' }"
					(input)="this.newRequestData.description = $any($event.target).value"
					[value]="this.newRequestData.description | deNLize"
					#descriptionTextarea>
				</textarea>
			</div>
			<div class="duplicate-custom-field">
				<div class="input-content-container">
					@if (!isCustomfieldLoading && newCustomfields && newCustomfields.length > 0) {
						<div class="content-col-header active no-collapse">
							<span>{{ labels.lbl_geral_campos_customizados }}:</span>
						</div>
						<div class="content-col static customfields">
							<pcp-request-customfield [setCustomfields]="newCustomfields" (customfields)="newCustomfields = $event">
							</pcp-request-customfield>
						</div>
					}
				</div>
			</div>
			<div class="button-container">
				<span class="button" id="closeButton" (click)="closeDuplicateRequest(duplyRequestButton)">{{
					labels.lbl_geral_fechar
				}}</span>
			</div>
		</div>
	}

	@if (requestData.service_type === 'Incident') {
		<div class="large-button" (click)="isOpeningRelatedRequest = !isOpeningRelatedRequest">
			<div>
				<span>{{ labels.lbl_geral_abrir_chamado_relacionado }}</span>
				<span [ngClass]="{ 'rotate-180': !isOpeningRelatedRequest }"><fa-icon [icon]="icons.faAngleDown"></fa-icon></span>
			</div>
		</div>
	}
	@if (isOpeningRelatedRequest) {
		<div class="related-requests">
			<pcp-request-opening [options]="$any(relatedRequestOptions)"></pcp-request-opening>
		</div>
	}
</div>
